import { LongPoll } from 'phoenix';
import getHooks from './hooks';

export default async () => {
  const { Socket } = await import('phoenix');
  const { LiveSocket } = await import('phoenix_live_view');
  const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');
  const hooks = await getHooks();
  const liveSocket = new LiveSocket('/live', Socket, {
    params: { _csrf_token: csrfToken },
    hooks,
  });
  const socket = liveSocket.getSocket();
  socket.timeout = 3000; // Timeout after 3s instead of 10s
  liveSocket.connect();
  const channel = socket.channels.find((e) => e.state === 'joining');
  if (channel) {
    // Check if succesfully connected after 3.5s
    // TODO find an event to listen to instead of using setTimeout
    setTimeout(() => {
      if (channel.state === 'errored') {
        console.warn('LiveView connection failed. This could be due to a proxy or firewall blocking websockets. Falling back to long polling.');
        liveSocket.disconnect();
        const pollingLiveSocket = new LiveSocket('/live', Socket, {
          params: { _csrf_token: csrfToken },
          transport: LongPoll,
          hooks,
        });
        pollingLiveSocket.connect();
      }
    }, 3500);
  }
};
